import { useRef } from "react";
import {
  useScroll,
  useTransform
} from "framer-motion";

export default function Parallax(Y){
    function useParallax(value, distance) {
        return useTransform(value, [0, 1], [-distance, distance]);
    }
    const ref = useRef(null);
    const { scrollYProgress } = useScroll({ target: ref });
    return useParallax(scrollYProgress, Y);
}